
const getImageUrl = (backgroundImage, isMobile, isPoster, withPosition = false, urlOnly = false) => {
    const flyImageUrl = pmkinoFrontVars && pmkinoFrontVars.cliData && pmkinoFrontVars.cliData.flyImageUrl ? pmkinoFrontVars.cliData.flyImageUrl : ''
    const flyImageActive = pmkinoFrontVars && pmkinoFrontVars.cliData && pmkinoFrontVars.cliData.flyImageActive ? pmkinoFrontVars.cliData.flyImageActive : false
    if(!backgroundImage) {
        return ({
            finalImageURl: null,
            url: null
        })
    }

    const url = urlOnly ? backgroundImage : backgroundImage.url
    const position = urlOnly ? null : backgroundImage.positionY ? backgroundImage.positionY : backgroundImage.position
    const positionX = urlOnly ? null : backgroundImage.positionX ? backgroundImage.positionX : 50
    let sizeQuery = ''
    let urlParams = ''
    
    if(isPoster) {
        if(url.search("orchestrationlayer.cloudticket.net") !== -1 || url.search("cineorder-content-uat.cloudticket.net") !== -1 || url.search("contentservice.cineorder.shop") !== -1 ) {
            sizeQuery = "&size=400"
        }
    } else {
        if(url.search("orchestrationlayer.cloudticket.net") !== -1 || url.search("cineorder-content-uat.cloudticket.net") !== -1 || url.search("contentservice.cineorder.shop") !== -1) {
            if(isMobile) {
                sizeQuery = "&size=1000"
            } else { 
                sizeQuery = "&size=2000"
            }
        }
    }
    
    let sizedImageUrl = url + sizeQuery
    
    let finalImageURl = sizedImageUrl
    
    if(flyImageUrl && !sizeQuery && flyImageActive) {
        if(isPoster) {
            if(isMobile) {
                urlParams = 'q_60,w_300/'
            } else {
                urlParams = 'q_60,w_400/'
            }
        } else {
            if(isMobile) {
                urlParams = 'q_60,w_1500/'
            } else {
                urlParams = 'q_60,w_2000/'
            }
        }
        
        finalImageURl = flyImageUrl + urlParams + encodeURIComponent(sizedImageUrl)
    }
    
    return  ({
        finalImageURl: finalImageURl,
        imageUrl: sizedImageUrl,
        position: withPosition && position && positionX ? `${positionX}% ${position}%` : 'top'
    })

}

export default getImageUrl